import React, { FC } from 'react';
import { ApplicationRecord } from '~/types/applications';
import { useApiLocalization } from '~/hooks/useApiLocalization';
import { Skeleton } from '@material-ui/lab';
import { Longdash } from '~/utils';

interface ApplicationStagesListProps {
  application: ApplicationRecord;
}

export const ApplicationStagesList: FC<ApplicationStagesListProps> = (props) => {
  const { application } = props;
  const { data: translations, isLoading } = useApiLocalization(
    getTranslationPrefix(application),
    !!application
  );
  const translatedStages = application?.currentStages?.map(
    (stageKey) =>
      translations?.[`${getTranslationPrefix(application)}.stage.${stageKey}.name`] ?? stageKey
  );

  return <>{isLoading ? <Skeleton width={200} /> : translatedStages?.join(', ') || Longdash}</>;
};

export const getTranslationPrefix = (record: ApplicationRecord) => `bpm.application.${record.type}`;
